import { Typography } from '@mui/material';
import { memo } from 'react';
import type { HighlightableContentProps as Props } from './types';

export const HighlightableContent = memo(({ content, ...rest }: Props) => {
  return (
    <Typography component="p" variant="body4" fontWeight={700} {...rest}>
      {content}
    </Typography>
  );
});

HighlightableContent.displayName = 'HighlightableContent';
